export default [
    {id: 1, collection: 'organicDyes', power: 2, reward: [
        {name: 'currencyGalleryRedGain', type: 'mult', value: 1.25}
    ], color: 'red', icons: [
        {"x": 0, "y": 0, "rotate": 135, "size": 1, "icon": "mdi-ladybug"},
        {"x": 0.9, "y": -0.15, "rotate": 40, "size": 0.9, "icon": "mdi-ladybug"},
        {"x": 0.3, "y": -0.7, "rotate": -10, "size": 1.05, "icon": "mdi-ladybug"},
        {"x": 0.5, "y": 0.75, "rotate": -70, "size": 0.75, "icon": "mdi-ladybug"},
        {"x": -0.65, "y": -0.55, "rotate": 135, "size": 0.85, "icon": "mdi-ladybug"},
        {"x": -0.85, "y": 0.1, "rotate": -40, "size": 1.15, "icon": "mdi-ladybug"},
        {"x": -0.8, "y": 0.9, "rotate": 170, "size": 0.95, "icon": "mdi-ladybug"},
        {"x": -0.1, "y": 0.65, "rotate": -120, "size": 1, "icon": "mdi-ladybug"}
    ]},
    {id: 2, collection: 'organicDyes', power: 2, reward: [
        {name: 'currencyGalleryOrangeGain', type: 'mult', value: 1.25}
    ], color: 'orange', icons: [
        {"x": -0.7, "y": -0.3, "rotate": 0, "size": 1.2, "icon": "mdi-bird"},
        {"x": 0, "y": -0.55, "rotate": 0, "size": 1.2, "icon": "mdi-bird"},
        {"x": 0.75, "y": -0.45, "rotate": 0, "size": 1.2, "icon": "mdi-bird"},
        {"x": 0.25, "y": 0, "rotate": 125, "size": 0.85, "icon": "mdi-feather"},
        {"x": -0.4, "y": 0.3, "rotate": 160, "size": 0.85, "icon": "mdi-feather"},
        {"x": 0.65, "y": 0.95, "rotate": 60, "size": 0.85, "icon": "mdi-feather"},
        {"x": -0.4, "y": 0.9, "rotate": -135, "size": 0.85, "icon": "mdi-feather"}
    ]},
    {id: 3, collection: 'organicDyes', power: 2, reward: [
        {name: 'currencyGalleryYellowGain', type: 'mult', value: 1.25}
    ], color: 'yellow', icons: [
        {"x": 0, "y": 0.35, "rotate": 0, "size": 2, "icon": "mdi-cup"},
        {"x": -0.75, "y": 0.5, "rotate": 0, "size": 1.25, "icon": "mdi-fruit-citrus"},
        {"x": 0.5, "y": -0.5, "rotate": 0, "size": 2, "icon": "mdi-spoon-sugar"}
    ]},
    {id: 4, collection: 'organicDyes', power: 2, reward: [
        {name: 'currencyGalleryGreenGain', type: 'mult', value: 1.25}
    ], color: 'green', icons: [
        {"x": -0.55, "y": 0.5, "rotate": 0, "size": 2.75, "icon": "mdi-waves"},
        {"x": 0.55, "y": 0.5, "rotate": 0, "size": 2.75, "icon": "mdi-waves"},
        {"x": -0.2, "y": -0.1, "rotate": 0, "size": 1.25, "icon": "mdi-scent"},
        {"x": 0.25, "y": 0, "rotate": 0, "size": 1.4, "icon": "mdi-scent"},
        {"x": 0.7, "y": 0, "rotate": 0, "size": 1.1, "icon": "mdi-scent"}
    ]},

    {id: 5, collection: 'artDisplay', power: 2, reward: [
        {name: 'currencyGalleryBeautyGain', type: 'mult', value: 1.25}
    ], color: 'pale-purple', icons: [
        {"x": -0.9, "y": -0.25, "rotate": 0, "size": 1.25, "icon": "mdi-image-filter-black-white"},
        {"x": 0, "y": -0.25, "rotate": 0, "size": 1.35, "icon": "mdi-image-area"},
        {"x": 0.9, "y": -0.25, "rotate": 0, "size": 1.25, "icon": "mdi-image-broken"},
        {"x": -0.55, "y": 0.7, "rotate": 0, "size": 1.75, "icon": "mdi-human-male-female-child"},
        {"x": 0.7, "y": 0.75, "rotate": 0, "size": 1.5, "icon": "mdi-human-handsdown"}
    ]},
    {id: 6, collection: 'artDisplay', power: 1, reward: [
        {name: 'galleryColorGain', type: 'mult', value: 1.1}
    ], color: 'dark-grey', icons: [
        {"x": 0, "y": 0, "rotate": 0, "size": 3, "icon": "mdi-artboard"},
        {"x": 0, "y": 0.1, "rotate": 0, "size": 1.15, "icon": "mdi-draw"},
        {"x": 0, "y": 1.3, "rotate": 45, "size": 1, "icon": "mdi-pencil"},
        {"x": -0.4, "y": 1.2, "rotate": 20, "size": 1, "icon": "mdi-pencil"}
    ]},
    {id: 7, collection: 'artDisplay', power: 1, reward: [
        {name: 'galleryInspirationStart', type: 'base', value: 5}
    ], color: 'teal', icons: [
        {"x": -0.9, "y": 0, "rotate": 135, "size": 1.5, "icon": "mdi-fountain-pen"},
        {"x": -0.45, "y": 0, "rotate": 135, "size": 1.5, "icon": "mdi-grease-pencil"},
        {"x": 0, "y": 0, "rotate": 135, "size": 1.5, "icon": "mdi-lead-pencil"},
        {"x": 0.45, "y": 0, "rotate": 135, "size": 1.5, "icon": "mdi-pen"},
        {"x": 0.9, "y": 0, "rotate": 135, "size": 1.5, "icon": "mdi-pencil"}
    ]},
    {id: 8, collection: 'artDisplay', power: 2, reward: [
        {name: 'galleryInspirationStart', type: 'base', value: 3}
    ], color: 'orange', icons: [
        {"x": -0.25, "y": 0, "rotate": 0, "size": 2, "icon": "mdi-gradient-horizontal"},
        {"x": 0.75, "y": 0.2, "rotate": 0, "size": 1.5, "icon": "mdi-spray"},
        {"x": -0.6, "y": -0.35, "rotate": 0, "size": 2, "icon": "mdi-ruler-square"}
    ]},
    {id: 9, collection: 'artDisplay', power: 3, color: 'pale-pink', icons: [
        {"x": 0, "y": -0.35, "rotate": 0, "size": 2, "icon": "mdi-drawing-box"},
        {"x": -0.5, "y": 0.9, "rotate": 0, "size": 1.5, "icon": "mdi-palette"},
        {"x": 0.1, "y": 0.5, "rotate": 0, "size": 1, "icon": "mdi-brush"},
        {"x": 0.9, "y": 0.7, "rotate": -90, "size": 1.5, "icon": "mdi-palette-swatch-variant"}
    ]},
    {id: 10, collection: 'artDisplay', power: 2, reward: [
        {name: 'galleryInspirationIncrement', type: 'mult', value: 1 / 1.1}
    ], color: 'light-blue', icons: [
        {"x": -0.8, "y": -0.9, "rotate": 0, "size": 2, "icon": "mdi-format-line-style"},
        {"x": 0, "y": -0.9, "rotate": 0, "size": 2, "icon": "mdi-format-line-style"},
        {"x": 0.8, "y": -0.9, "rotate": 0, "size": 2, "icon": "mdi-format-line-style"},
        {"x": 0.7, "y": 0, "rotate": 0, "size": 1.5, "icon": "mdi-format-paint"},
        {"x": -0.45, "y": 0.6, "rotate": -155, "size": 1, "icon": "mdi-brush-variant"},
        {"x": -0.5, "y": 1, "rotate": 0, "size": 1.25, "icon": "mdi-pail"}
    ]},
    {id: 11, collection: 'artDisplay', power: 2, reward: [
        {name: 'galleryInspirationIncrement', type: 'mult', value: 1 / 1.05},
        {name: 'galleryInspirationStart', type: 'base', value: 2}
    ], color: 'light-green', icons: [
        {"x": 0, "y": -0.4, "rotate": 0, "size": 3, "icon": "mdi-image-area"},
        {"x": 0.35, "y": 0.65, "rotate": -45, "size": 1.5, "icon": "mdi-tag-outline"},
        {"x": 0.35, "y": 0.65, "rotate": 0, "size": 0.65, "icon": "mdi-gesture"},
        {"x": 0.72, "y": 0.47, "rotate": 0, "size": 1, "icon": "mdi-fountain-pen"}
    ]},
    {id: 12, collection: 'artDisplay', power: 1, reward: [
        {name: 'currencyGalleryCashGain', type: 'mult', value: 1.1},
        {name: 'galleryInspirationStart', type: 'base', value: 3}
    ], color: 'red', icons: [
        {"x": -0.1, "y": -0.15, "rotate": 0, "size": 1.25, "icon": "mdi-eyedropper"},
        {"x": -0.35, "y": 0.35, "rotate": 0, "size": 0.8, "icon": "mdi-water-opacity"},
        {"x": -0.45, "y": 0.95, "rotate": 0, "size": 1.5, "icon": "mdi-bucket"},
        {"x": 0.65, "y": 0.3, "rotate": 90, "size": 1.2, "icon": "mdi-palette-swatch"}
    ]},
    {id: 13, collection: 'artDisplay', power: 2, reward: [
        {name: 'currencyGalleryCashGain', type: 'mult', value: 1.2}
    ], color: 'skyblue', icons: [
        {"x": 0, "y": -0.61, "rotate": 0, "size": 0.9, "icon": "mdi-shape"},
        {"x": -0.6, "y": 1, "rotate": 0, "size": 1, "icon": "mdi-human-greeting"},
        {"x": -0.35, "y": 1.1, "rotate": 0, "size": 0.5, "icon": "mdi-sack"},
        {"x": -0.15, "y": 1.1, "rotate": 0, "size": 0.5, "icon": "mdi-sack"},
        {"x": 0, "y": -0.7, "rotate": 0, "size": 1.5, "icon": "mdi-image-frame"},
        {"x": 0.55, "y": 1, "rotate": 0, "size": 1, "icon": "mdi-human-handsdown"},
        {"x": 0, "y": 0.1, "rotate": 0, "size": 0.8, "icon": "mdi-gavel"},
        {"x": 0.4, "y": 0.13, "rotate": 0, "size": 0.8, "icon": "mdi-cash-register"},
        {"x": -0.3, "y": 0.2, "rotate": 0, "size": 1, "icon": "mdi-human-male"}
    ]},
    {id: 14, collection: 'artDisplay', power: 1, reward: [
        {name: 'currencyGalleryBeautyGain', type: 'mult', value: 1.3},
        {name: 'currencyGalleryCashGain', type: 'mult', value: 1.1}
    ], color: 'yellow', icons: [
        {"x": -0.25, "y": 0, "rotate": 0, "size": 2, "icon": "mdi-image-outline"},
        {"x": -0.25, "y": -0.05, "rotate": 0, "size": 1, "icon": "mdi-face-woman-shimmer"},
        {"x": 0.1, "y": -0.4, "rotate": 0, "size": 1, "icon": "mdi-brush"},
        {"x": 0.8, "y": -0.5, "rotate": 0, "size": 1.5, "icon": "mdi-human-female"}
    ]},

    {id: 15, collection: 'deliveryService', power: 2, reward: [
        {name: 'currencyGalleryConverterCap', type: 'mult', value: 1.3}
    ], color: 'pale-green', icons: [
        {"x": -0.2, "y": 0, "rotate": 0, "size": 2, "icon": "mdi-delete-outline"},
        {"x": -0.2, "y": 0.1, "rotate": 0, "size": 0.75, "icon": "mdi-recycle"},
        {"x": -0.75, "y": 0.22, "rotate": 0, "size": 0.85, "icon": "mdi-shape"},
        {"x": 0.6, "y": -0.2, "rotate": 0, "size": 2.5, "icon": "mdi-human-greeting"},
        {"x": -0.05, "y": -0.8, "rotate": 20, "size": 1, "icon": "mdi-food-takeout-box"}
    ]},
    {id: 16, collection: 'deliveryService', power: 2, reward: [
        {name: 'currencyGalleryConverterGain', type: 'mult', value: 1.15}
    ], color: 'orange-red', icons: [
        {"x": 0, "y": 0, "rotate": 0, "size": 3, "icon": "mdi-moped"},
        {"x": 0, "y": -0.4, "rotate": 0, "size": 2, "icon": "mdi-walk"},
        {"x": -0.4, "y": -0.55, "rotate": 60, "size": 1, "icon": "mdi-pizza"}
    ]},
    {id: 17, collection: 'deliveryService', power: 2, reward: [
        {name: 'currencyGalleryPackageCap', type: 'mult', value: 1.25}
    ], color: 'brown', icons: [
        {"x": 0.4, "y": 0, "rotate": 0, "size": 2.5, "icon": "mdi-truck-flatbed"},
        {"x": -0.1, "y": -0.1, "rotate": 0, "size": 0.75, "icon": "mdi-package"},
        {"x": 0.25, "y": -0.1, "rotate": 0, "size": 0.75, "icon": "mdi-package"},
        {"x": -0.1, "y": -0.4, "rotate": 0, "size": 0.75, "icon": "mdi-package"},
        {"x": 0.25, "y": -0.4, "rotate": 0, "size": 0.75, "icon": "mdi-package"},
        {"x": -1, "y": 0.35, "rotate": 0, "size": 0.75, "icon": "mdi-package"},
        {"x": -0.65, "y": 0.35, "rotate": 0, "size": 0.75, "icon": "mdi-package"},
        {"x": -0.825, "y": 0.05, "rotate": 0, "size": 0.75, "icon": "mdi-package"}
    ]},
    {id: 18, collection: 'deliveryService', power: 2, reward: [
        {name: 'currencyGalleryPackageGain', type: 'mult', value: 1.15}
    ], color: 'red', icons: [
        {"x": -0.85, "y": 0, "rotate": 0, "size": 1.5, "icon": "mdi-bus-stop-covered"},
        {"x": 0.3, "y": 0.1, "rotate": 0, "size": 2, "icon": "mdi-bus-school"},
        {"x": 0.75, "y": -0.8, "rotate": 0, "size": 1, "icon": "mdi-town-hall"}
    ]},
    {id: 19, collection: 'deliveryService', power: 3, reward: [
        {name: 'galleryColorDrumCap', type: 'base', value: 3}
    ], color: 'dark-blue', icons: [
        {"x": 0.65, "y": 0, "rotate": 0, "size": 2, "icon": "mdi-factory"},
        {"x": -0.85, "y": 0.75, "rotate": 0, "size": 1, "icon": "mdi-barrel"},
        {"x": -0.35, "y": 0.75, "rotate": 0, "size": 1, "icon": "mdi-barrel"},
        {"x": -0.6, "y": 0.3, "rotate": 0, "size": 1, "icon": "mdi-barrel"},
        {"x": 0.9, "y": -0.75, "rotate": 0, "size": 1, "icon": "mdi-smoke"},
        {"x": -0.3, "y": -0.3, "rotate": 0, "size": 1, "icon": "mdi-forklift"},
        {"x": -0.7, "y": -0.27, "rotate": 0, "size": 0.6, "icon": "mdi-walk"}
    ]},
    {id: 20, collection: 'deliveryService', power: 3, reward: [
        {name: 'currencyGalleryConverterGain', type: 'mult', value: 1.1},
        {name: 'currencyGalleryPackageGain', type: 'mult', value: 1.1}
    ], color: 'cyan', icons: [
        {"x": 0.8, "y": 0.55, "rotate": 0, "size": 1.75, "icon": "mdi-ferry"},
        {"x": -0.5, "y": 0.65, "rotate": 0, "size": 1, "icon": "mdi-shipping-pallet"},
        {"x": -0.1, "y": 0.65, "rotate": 0, "size": 1, "icon": "mdi-shipping-pallet"},
        {"x": -1, "y": 0.65, "rotate": 0, "size": 1, "icon": "mdi-forklift"},
        {"x": -1.1, "y": 1.1, "rotate": 0, "size": 1.6, "icon": "mdi-rectangle"},
        {"x": -0.55, "y": 1.1, "rotate": 0, "size": 1.6, "icon": "mdi-rectangle"},
        {"x": -0.05, "y": 1.1, "rotate": 0, "size": 1.6, "icon": "mdi-rectangle"}
    ]},
    {id: 21, collection: 'deliveryService', power: 3, reward: [
        {name: 'currencyGalleryRedDrumCap', type: 'mult', value: 1.2}
    ], color: 'light-grey', icons: [
        {"x": -0.95, "y": 0.05, "rotate": 0, "size": 1.2, "icon": "mdi-truck-cargo-container"},
        {"x": -0.2, "y": 0.05, "rotate": 0, "size": 1.2, "icon": "mdi-truck-cargo-container"},
        {"x": 0.55, "y": 0.05, "rotate": 0, "size": 1.2, "icon": "mdi-truck-cargo-container"},
        {"x": -1.15, "y": 0.5, "rotate": 90, "size": 1, "icon": "mdi-road"},
        {"x": -0.7, "y": 0.5, "rotate": 90, "size": 1, "icon": "mdi-road"},
        {"x": -0.25, "y": 0.5, "rotate": 90, "size": 1, "icon": "mdi-road"},
        {"x": 0.25, "y": 0.5, "rotate": 90, "size": 1, "icon": "mdi-road"},
        {"x": 0.7, "y": 0.5, "rotate": 90, "size": 1, "icon": "mdi-road"},
        {"x": 1.15, "y": 0.5, "rotate": 90, "size": 1, "icon": "mdi-road"},
        {"x": 1.1, "y": -0.48, "rotate": 0, "size": 1, "icon": "mdi-traffic-light"},
        {"x": 1.1, "y": 0, "rotate": 0, "size": 1.25, "icon": "mdi-sign-pole"}
    ]},
    {id: 22, collection: 'deliveryService', power: 3, reward: [
        {name: 'galleryInspirationStart', type: 'base', value: 2},
        {name: 'galleryColorDrumCap', type: 'base', value: 2}
    ], color: 'light-blue', icons: [
        {"x": 0, "y": -0.55, "rotate": 0, "size": 1.5, "icon": "mdi-quadcopter"},
        {"x": 0, "y": 0.4, "rotate": 0, "size": 1.2, "icon": "mdi-parachute"},
        {"x": 0, "y": 0.95, "rotate": 0, "size": 1.4, "icon": "mdi-package"},
        {"x": -0.85, "y": 0, "rotate": 0, "size": 1, "icon": "mdi-cloud"},
        {"x": 1, "y": -0.4, "rotate": 0, "size": 1, "icon": "mdi-clouds"}
    ]},
    {id: 23, collection: 'deliveryService', power: 3, reward: [
        {name: 'galleryColorDrumCap', type: 'base', value: 2},
        {name: 'currencyGalleryCashGain', type: 'mult', value: 1.1}
    ], color: 'orange', icons: [
        {"x": 0.3, "y": 0.05, "rotate": 0, "size": 1.75, "icon": "mdi-tow-truck"},
        {"x": 1.1, "y": 0.15, "rotate": 0, "size": 1, "icon": "mdi-traffic-cone"},
        {"x": -1.1, "y": 0.15, "rotate": 0, "size": 1, "icon": "mdi-traffic-cone"},
        {"x": -0.5, "y": 0.1, "rotate": -25, "size": 1.25, "icon": "mdi-car-side"}
    ]},

    {id: 24, collection: 'abstractShapes', power: 5, reward: [], color: 'dark-blue', icons: [
        {"x": 0, "y": -0.15, "rotate": 0, "size": 4, "icon": "mdi-rectangle-outline"},
        {"x": -0.5, "y": 0.8, "rotate": 0, "size": 0.75, "icon": "mdi-circle"},
        {"x": 0.5, "y": 0.8, "rotate": 0, "size": 0.75, "icon": "mdi-circle"}
    ]},
    {id: 25, collection: 'abstractShapes', power: 3, reward: [
        {name: 'galleryInspirationStart', type: 'base', value: 6},
    ], color: 'pale-orange', icons: [
        {"x": -0.45, "y": -0.5, "rotate": 0, "size": 0.75, "icon": "mdi-circle"},
        {"x": 0.45, "y": -0.5, "rotate": 0, "size": 0.75, "icon": "mdi-circle"},
        {"x": 0, "y": 0.5, "rotate": 0, "size": 5, "icon": "mdi-minus"}
    ]},
    {id: 26, collection: 'abstractShapes', power: 4, reward: [
        {name: 'currencyGalleryBlueGain', type: 'mult', value: 1.25},
    ], color: 'blue', icons: [
        {"x": 0, "y": 0, "rotate": 90, "size": 4, "icon": "mdi-heat-wave"}
    ]},
    {id: 27, collection: 'abstractShapes', power: 4, reward: [
        {name: 'currencyGalleryPurpleGain', type: 'mult', value: 1.25},
    ], color: 'purple', icons: [
        {"x": 0, "y": 0.8, "rotate": 90, "size": 3, "icon": "mdi-minus"},
        {"x": 0, "y": -0.55, "rotate": 0, "size": 3, "icon": "mdi-circle-outline"}
    ]},
    {id: 28, collection: 'abstractShapes', power: 6, reward: [
        {name: 'currencyGalleryOrangeDrumCap', type: 'mult', value: 1.2},
    ], color: 'brown', icons: [
        {"x": 0, "y": 0.65, "rotate": 0, "size": 2.75, "icon": "mdi-square-outline"},
        {"x": 0, "y": -0.65, "rotate": 0, "size": 2.75, "icon": "mdi-triangle-outline"}
    ]},

    {id: 29, collection: 'artOfWar', power: 6, reward: [
        {name: 'currencyGalleryDeep-orangeGain', type: 'mult', value: 1.25},
    ], color: 'deep-orange', icons: [
        {"x": 0.8, "y": 0.1, "rotate": 0, "size": 2, "icon": "mdi-human-handsdown"},
        {"x": 0.4, "y": 0.05, "rotate": -105, "size": 1, "icon": "mdi-bow-arrow"},
        {"x": -0.7, "y": -0.3, "rotate": -120, "size": 1, "icon": "mdi-arrow-projectile"},
        {"x": -0.85, "y": -0.5, "rotate": 0, "size": 0.6, "icon": "mdi-fire"},
        {"x": -0.6, "y": -0.4, "rotate": 0, "size": 0.5, "icon": "mdi-fire"}
    ]},
    {id: 30, collection: 'artOfWar', power: 6, reward: [
        {name: 'currencyGalleryAmberGain', type: 'mult', value: 1.25},
    ], color: 'amber', icons: [
        {"x": 0, "y": 0.05, "rotate": 70, "size": 3, "icon": "mdi-sword"},
        {"x": -0.4, "y": -0.4, "rotate": -105, "size": 0.85, "icon": "mdi-shimmer"},
        {"x": 0.65, "y": -0.75, "rotate": -15, "size": 0.85, "icon": "mdi-shimmer"},
        {"x": 0.55, "y": 0.15, "rotate": 115, "size": 0.85, "icon": "mdi-shimmer"}
    ]},
    {id: 31, collection: 'artOfWar', power: 6, reward: [
        {name: 'galleryCanvasSpeed', type: 'mult', value: 1.25},
    ], color: 'pale-blue', icons: [
        {"x": -0.55, "y": -0.1, "rotate": 0, "size": 1.2, "icon": "mdi-human-handsdown"},
        {"x": 0.5, "y": -0.1, "rotate": 0, "size": 1.2, "icon": "mdi-human-handsdown"},
        {"x": 0.15, "y": -0.25, "rotate": 0, "size": 0.65, "icon": "mdi-sword"},
        {"x": -0.2, "y": -0.25, "rotate": 90, "size": 0.65, "icon": "mdi-sword"},
        {"x": 0.15, "y": -0.8, "rotate": 0, "size": 1.1, "icon": "mdi-tree"},
        {"x": -0.05, "y": 0.2, "rotate": 0, "size": 0.35, "icon": "mdi-grass"},
        {"x": 0.6, "y": 0.9, "rotate": 0, "size": 1.6, "icon": "mdi-human-greeting"},
        {"x": 0.15, "y": 0.45, "rotate": 0, "size": 0.7, "icon": "mdi-camera"}
    ]},
    {id: 32, collection: 'artOfWar', power: 7, reward: [
        {name: 'galleryCanvasSize', type: 'base', value: 2},
    ], color: 'pink-purple', icons: [
        {"x": 0.5, "y": 0.2, "rotate": 0, "size": 2, "icon": "mdi-horse-human"},
        {"x": 0.15, "y": -0.75, "rotate": 0, "size": 1.4, "icon": "mdi-bookmark"},
        {"x": 0.15, "y": -0.4, "rotate": 90, "size": 1, "icon": "mdi-minus-thick"},
        {"x": 0.15, "y": -0.1, "rotate": 90, "size": 1, "icon": "mdi-minus-thick"},
        {"x": -0.55, "y": 0.4, "rotate": 0, "size": 1.25, "icon": "mdi-human-greeting"},
        {"x": -0.85, "y": -0.05, "rotate": 25, "size": 0.7, "icon": "mdi-sword"}
    ]},

    {id: 33, collection: 'handmade', power: 8, reward: [], color: 'light-blue', icons: [
        {"x": 0, "y": 0, "rotate": -90, "size": 3, "icon": "mdi-bottle-tonic-outline"},
        {"x": 0.3, "y": 0.2, "rotate": 0, "size": 1, "icon": "mdi-ferry"}
    ]},
    {id: 34, collection: 'handmade', power: 6, reward: [
        {name: 'currencyGalleryYellowDrumCap', type: 'mult', value: 1.2},
    ], color: 'red', icons: [
        {"x": -0.2, "y": 0.15, "rotate": 10, "size": 3, "icon": "mdi-tshirt-crew"},
        {"x": 0.5, "y": -0.15, "rotate": -125, "size": 1, "icon": "mdi-lasso"},
        {"x": 0.9, "y": -0.3, "rotate": 195, "size": 1, "icon": "mdi-arrow-projectile"},
        {"x": 0.95, "y": -0.15, "rotate": 215, "size": 1, "icon": "mdi-arrow-projectile"}
    ]},
    {id: 35, collection: 'handmade', power: 6, reward: [
        {name: 'currencyGalleryCashGain', type: 'mult', value: 1.25},
    ], color: 'wooden', icons: [
        {"x": -0.85, "y": 0.1, "rotate": 0, "size": 1.5, "icon": "mdi-cupboard"},
        {"x": 0.55, "y": -0.15, "rotate": 35, "size": 1, "icon": "mdi-hand-saw"},
        {"x": 0, "y": 0, "rotate": 0, "size": 2, "icon": "mdi-walk"},
        {"x": 0.85, "y": 0.25, "rotate": 0, "size": 1.3, "icon": "mdi-table-furniture"},
        {"x": 0.85, "y": 0, "rotate": 0, "size": 1.4, "icon": "mdi-minus-thick"}
    ]},
    {id: 36, collection: 'handmade', power: 5, reward: [
        {name: 'galleryInspirationStart', type: 'base', value: 7},
    ], color: 'beige', icons: [
        {"x": 0.05, "y": 0.2, "rotate": -120, "size": 1, "icon": "mdi-screwdriver"},
        {"x": -0.5, "y": 0.15, "rotate": 0, "size": 2, "icon": "mdi-human-handsdown"},
        {"x": 0.45, "y": 0.4, "rotate": 0, "size": 1, "icon": "mdi-dog-side"},
        {"x": 0.4, "y": 0.6, "rotate": 0, "size": 1, "icon": "mdi-minus"}
    ]},
    {id: 37, collection: 'handmade', power: 7, reward: [
        {name: 'currencyGalleryLight-greenGain', type: 'mult', value: 1.25},
    ], color: 'light-green', icons: [
        {"x": 0, "y": -0.05, "rotate": 0, "size": 2, "icon": "mdi-nature"},
        {"x": 0, "y": 0.45, "rotate": 0, "size": 2, "icon": "mdi-pot"},
        {"x": -0.8, "y": -0.25, "rotate": -10, "size": 0.75, "icon": "mdi-content-cut"},
        {"x": 0.5, "y": -0.5, "rotate": -25, "size": 0.75, "icon": "mdi-shimmer"}
    ]},
    {id: 38, collection: 'handmade', power: 7, reward: [
        {name: 'currencyGalleryTealGain', type: 'mult', value: 1.25},
    ], color: 'teal', icons: [
        {"x": 0.5, "y": 0.35, "rotate": 0, "size": 3, "icon": "mdi-human-female-dance"},
        {"x": -0.15, "y": -0.4, "rotate": -70, "size": 2, "icon": "mdi-brush"},
        {"x": -0.8, "y": 0.3, "rotate": 35, "size": 1.5, "icon": "mdi-palette"}
    ]},

    {id: 39, collection: 'specialGadgets', power: 'adaptive', reward: [
        {name: 'galleryInspirationBase', type: 'mult', value: 10},
        {name: 'galleryInspirationIncrement', type: 'mult', value: 2},
        {name: 'galleryInspirationStart', type: 'mult', value: 0}
    ], color: 'babypink', icons: [
        {"x": 0, "y": 0.4, "rotate": 0, "size": 3, "icon": "mdi-human-handsdown"},
        {"x": 0.7, "y": -0.65, "rotate": 30, "size": 1.2, "icon": "mdi-help"},
        {"x": 0, "y": -0.85, "rotate": 0, "size": 1, "icon": "mdi-help"},
        {"x": -0.6, "y": -0.6, "rotate": -25, "size": 0.9, "icon": "mdi-help"}
    ]},
    {id: 40, collection: 'specialGadgets', power: 'adaptive', reward: [
        {name: 'galleryColorDrumChance', type: 'base', value: -0.1},
        {name: 'galleryColorDrumChance', type: 'mult', value: 0.25}
    ], color: 'aqua', icons: [
        {"x": 0, "y": 0.1, "rotate": 90, "size": 2, "icon": "mdi-barrel"},
        {"x": -0.9, "y": 0.6, "rotate": 35, "size": 1, "icon": "mdi-liquid-spot"},
        {"x": -0.2, "y": 0.85, "rotate": -40, "size": 1, "icon": "mdi-liquid-spot"},
        {"x": 0.05, "y": 0.85, "rotate": 15, "size": 1, "icon": "mdi-liquid-spot"},
        {"x": 0.3, "y": 0.9, "rotate": 90, "size": 1, "icon": "mdi-liquid-spot"},
        {"x": 0.7, "y": 0.9, "rotate": -25, "size": 1, "icon": "mdi-liquid-spot"}
    ]},
];
